export default __webpack_public_path__ + "static/pointOneSelected-c534b2c5b3b459d0de88614ac421e595.png";